"use client";

import React from "react";
import { PhoneCall, Zap, Clock, ShieldAlert } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function RapidResponse() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="247-rapid-response" className="dark bg-background text-foreground py-16 md:py-24 relative overflow-hidden border-y border-border">
      {}
      <div className="absolute top-0 right-0 w-full md:w-1/2 h-full bg-primary/5 blur-[120px] pointer-events-none" />

      <div className="max-w-[1440px] mx-auto px-6 md:px-12 relative z-10">
        <div ref={contentRef} className={cn("grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          {}
          <div className="lg:col-span-8 flex flex-col items-start">
            {}
            <div className="font-mono text-sm tracking-widest text-muted-foreground mb-6 flex items-center gap-4">
              <span>[04 // 08]</span>
              <div className="h-px w-12 bg-border relative">
                <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1 h-1 bg-primary" />
              </div>
              <span className="uppercase text-primary font-semibold">Critical Response</span>
            </div>

            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-tight mb-6">
              When the Grid Fails, <br className="hidden md:block" />
              <span className="text-primary">We Don't.</span>
            </h2>

            <p className="font-default text-lg md:text-xl text-muted-foreground max-w-2xl mb-10 leading-relaxed">
              Electrical emergencies pose immediate risks to your property and safety. Our licensed rapid-response technicians are on standby 24/7, equipped to handle critical failures, exposed wiring, and sudden outages with precision and speed.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button size="lg" className="h-14 px-8 text-lg font-bold shadow-lg shadow-primary/20" asChild>
                <Link to="/LetsTalkPage">
                  <Zap className="mr-2 size-5" />
                  Dispatch Technician Now
                </Link>
              </Button>
              <Button size="lg" variant="outline" className="h-14 px-8 text-lg font-bold border-2 hover:bg-primary/10 hover:text-primary hover:border-primary transition-colors" asChild>
                <Link to="tel:(555) 123-4567">
                  <PhoneCall className="mr-2 size-5" />
                  (555) 123-4567
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-4">
            <Card className="bg-card/40 border-border backdrop-blur-md shadow-2xl relative overflow-hidden">
              {}
              <div className="absolute top-0 left-0 w-full h-1 bg-destructive" />
              
              <CardHeader className="pb-4">
                <CardTitle className="flex items-center gap-3 text-2xl font-default">
                  <ShieldAlert className="size-8 text-destructive" />
                  Emergency Protocol
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="bg-primary/10 p-3 rounded-md shrink-0">
                    <Clock className="size-6 text-primary" />
                  </div>
                  <div>
                    <h4 className="font-default font-bold text-lg text-foreground">24/7 Availability</h4>
                    <p className="text-muted-foreground text-sm mt-1 leading-relaxed">
                      Nights, weekends, and holidays. We are always on call for urgent repairs.
                    </p>
                  </div>
                </div>
                
                {}
                <div className="w-full h-px bg-border relative">
                  <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-1 bg-primary" />
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="bg-primary/10 p-3 rounded-md shrink-0">
                    <Zap className="size-6 text-primary" />
                  </div>
                  <div>
                    <h4 className="font-default font-bold text-lg text-foreground">Priority Routing</h4>
                    <p className="text-muted-foreground text-sm mt-1 leading-relaxed">
                      Emergency calls bypass standard queues for immediate technician dispatch.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}